<template>
  <div class="container">
    <div id="region_top">
      <div class="top-section">
      <div class="ranking">

        <div class="ranking-card" @click="goto_rank(1, 1)">
          <div class="ranking1">
            <img src="../assets/img/new2024/arrogance-icon.png" alt="" />
            <span>豪气榜</span>
          </div>
          <div class="ranking2">
            <div class="image-container">
              <img v-for="(item, index) in ary1" :key="index" :src="item" class="image" />
              </div>
            </div>
        </div>

        <div class="ranking-card" @click="goto_rank(2, 1)">
          <div class="ranking1">
            <img src="../assets/img/new2024/charm-icon.png" alt="" />
            <span>魅力榜</span>
          </div>
          <div class="ranking2">
            <div class="image-container">
              <img v-for="(item, index) in ary2" :key="index" :src="item" class="image" />
            </div>
          </div>
        </div>
      </div>

      <div class="actions">
        <div class="action-item" @click="goto_guidebook()">
          <div class="action-icon ub ub-pc ub-ac">
            <img class="new-friends" src="../assets/img/new2024/guide.png" alt="#"/>
          </div>
          <span>新手指南</span>
        </div>
        <div class="action-item" @click="goto_chart_admin()">
          <div class="action-icon ub ub-pc ub-ac">
            <img class="feedback" src="../assets/img/new2024/kefu.png" alt="#" />
          </div>
          <span>客服</span>
        </div>
      </div>
    </div>

    <div class="match-section">
      <div class="match-option" @click="match_rand()">
        <span>随机匹配</span>
        <span v-if="userinfo.vip_level <= 0" class="text">剩余次数:{{match_count_max - match_rand_used >= 0 ? match_count_max - match_rand_used : 0}}次</span>
        <div v-if="userinfo.vip_level > 0" class="text">剩余次数: <span>无限次</span></div>
      </div>
      <div class="match-option" @click="match_diff()">
        <span>异性匹配</span>
        <div v-if="userinfo.vip_level <= 0" class="text">剩余次数: <span>{{  match_count_othersex - match_diff_used >= 0 ? match_count_othersex - match_diff_used: 0 }}次</span></div>
        <div v-if="userinfo.vip_level > 0" class="text">剩余次数: <span>无限次</span></div>
      </div>
    </div>

    <div v-if="festival_activity" class="notice ub ub-pc ub-ac2" @click="notice_dtl()">
      <div class="scroll-container">
        <span class="scroll-text">{{ festival_info.act_title }}</span>
      </div>
    </div>
    </div>

    <div id="region_recommend_head" class="online-count">
      <span>推荐用户</span>
      <div class="online-users">
        在线人数：<span>{{ online_num }}</span>
      </div>
    </div>

    <ul class="recommend-section" :style="{'height':h}">
     <li class="user-card" v-for="(item, index) in least_user" :key="index">
        <div class="user-info">
          <div class="avatar">
            <img v-if="item.photo" :src="item.photo" alt="" />
          </div>
          <div class="details">
            <div class="information1">
              <span>{{ item.nick.length > 8 ? item.nick.substr(0,7) + '...' : item.nick }}</span>
              <div class="age-range">
                <img v-if="item.sex == '男生'" src="../assets/img/男.png" alt="#"/>
                <img v-if="item.sex == '女生'" src="../assets/img/女.png" alt="#"/>
                <span>{{ item.age_range }}</span>
              </div>
            </div>
            <div class="information2">
              <div class="crad-value">
                <span>魅力值 {{ item.score_total }}</span>
              </div>
              <div class="crad-value">
                <span>豪气值 {{ item.coin_total }}</span>
              </div>
            </div>
            <div class="details-state">{{ item.dtm_sp }}前</div>
          </div>
        </div>
        <div class="match-button" @click="buildChart(item.uid)">
          <span>撩ta</span>
          <div class="love">
            <img class="love-icon" src="../assets/img/new2024/love.png" alt="#"/>
          </div>
        </div>
      </li>
      <div class="ub ub-ac ub-pc" style="height: 1.5rem;"></div>
    </ul>
    <div style="height: 3.3rem;"></div>

    <div class="no-404 ub ub-pc ub-ac ub-ver" v-if="userinfo == ''">
      <img src="../assets/img/new2024/404.png" alt="">

      <span class="tip-404">网络断了，透透气，马上回来</span>

      <div class="btn-404"><span>刷新一下</span></div>
    </div>

    <dlg ref="myForm_vip_pay" @formBehavior="formact_vip_pay"></dlg>
    <dlg ref="myForm_buyVip" @formBehavior="formact_buyVip"></dlg>
    <alert ref="myConfirm_buyCoin" @userBehavior="formact_buycoin"></alert>
    <alert ref="myConfirm_buyCoinOrChatCoin" @userBehavior="formact_buycoin_chatcoin"></alert>
    <popup ref="myForm_popup"></popup>
    <kill_alert ref="show_kill"></kill_alert>
    <first_charge ref="first_charge"></first_charge>
    <festival_activity ref="festival_activity"></festival_activity>
  </div>
</template>
<script>
import * as tool from "../api/common";
import { mapMutations, mapActions } from "vuex";
import Form_Popup from "../components/Popup.vue";
import Alert from "../components/Alert.vue";
import Form from "../components/Form.vue";
import Kill_Alert from "../components/Kill_Alert.vue";
import First_Charge from "../components/First_Charge.vue";
import Festival_Activity from "../components/Festival_Activity.vue";
export default {
  components: {
    alert: Alert,
    dlg: Form,
    popup: Form_Popup,
    kill_alert: Kill_Alert,
    first_charge: First_Charge,
    festival_activity: Festival_Activity
  },
  data() {
    return {
      userinfo: {
        vip_level: 0,
        vip_tag: 0,
        coin_left: 0,
        sex:""
      },
      h: "20rem",
      match_rand_used: 0,
      match_diff_used: 0,
      match_count_max: 0,
      match_count_othersex: 0,
      ary1: [],
      ary2: [],
      loading_tag: {
        rank1: false,
        rank2: false,
        match: false,
        recommend_user: false
      },
      festival_info: {},
      festival_activity: false
    };
  },
  computed: {
    uid_tag: function() {
      var uid = this.$store.state.uid;
      return uid;
    },
    dic_tag:function() {
      //加载dic信息
       var sysdic = this.$store.state.sysdic;
       return sysdic;
    },
    const_data_tag:function(){
      var const_data = this.$store.state.const_data;
      return const_data;
    },
    online_num: function() {
      return this.$store.state.online_count;
    },
    least_user: function() {
       var data = this.$store.state.least_online;
       data = this.format_online(data);
       return data;
     },
    loading_tags: function() {
      if (this.loading_tag.rank1 && this.loading_tag.rank2 && this.loading_tag.match && this.loading_tag.recommend_user) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    uid_tag(newVal, oldVal){
      //console.log("检测到uid变化,watch--->uid:" + newVal);
      var self = this;
      if (newVal) {
        setTimeout(() => {
          self.init_page();
        }, 300);
      }
    },
    dic_tag(newVal, oldVal){
      //console.log("检测到dic变化,watch--->dic:" + JSON.stringify(newVal));
       if (newVal) {
         this.match_count_max = newVal.match_count_max;

         //测试版本号是否一致，解决上线缓存问题
         this.check_appVersion();
       }
    },
    loading_tags(newVal, oldVal) {
      if (newVal) {
        this.$loading.close();
      }
    }
  },
  mounted() {
     this.$loading("加载中...");
     setTimeout(() => {
         this.$loading.close();
     }, 5000);
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo", "act_get_killinfo", "act_sub_coin"]), //引入方法

    //页面加载，获取数据
    init_page() {

      var uid = this.$store.state.uid;
      if (uid) {
        this.init_user(uid);
      }

      //拉取最新在线用户
      this.get_least_user();

      //获取在线用户量
      var online = this.$store.state.least_online.length;
      this.$store.dispatch("act_set_online_count", online);

      //检查是否被封号
      var kill_info = this.$store.state.kill_info;
      if (kill_info) {
        this.$refs.show_kill.show();
      }
      

      //加载dic信息
      var sysdic = this.$store.state.sysdic;
       if (sysdic) {
        //随机匹配次数
         this.match_count_max = sysdic.match_count_max;
         //异性匹配次数
         this.match_count_othersex = sysdic.match_count_max2;
         //检查版本
         this.check_appVersion();
         //检查节日活动
         if (sysdic.fest_vip == "1") {
            this.festival_activity = true;
           
            //节日活动
            this.init_festivalActivities();
         }
       }

      //获取用户匹配次数
      var self = this;
      self.match_rand_used = self.$store.state.objVal.match_rand;
      self.match_diff_used = self.$store.state.objVal.match_diff;

      self.loading_tag.match = true;

      //获取用户设置信息（音效设置，微信通知设置）---后续统计放到App.vue页面计算
      setTimeout(() => {
        self.get_setting();
      }, 1500);

      //获取榜单内容
      this.get_rank_data1();
      this.get_rank_data2();
      // this.$loading("正在加载中...");

      //控制界面元素高度（动态计算）
      this.wnd_ctrl();
    },

    //随机匹配
    match_rand() {
      this.check_uid();

      if(this.userinfo.vip_level > 0){
        this.match_dtl(0);
        return true;
      }

      //检查是否有匹配次数
      if(this.match_count_max - this.match_rand_used > 0){
        this.match_dtl(0);
      }else{
        this.$toast.center("今日匹配次数已用完~");
      }

    },
    //异性匹配
    match_diff() {
      this.check_uid();

      if(this.userinfo.vip_level > 0){
        this.match_dtl(1);
        return true;
      }

      //检查是否有匹配次数
      if(this.match_count_othersex - this.match_diff_used > 0){
        this.match_dtl(1);
      }
      else{
        this.checkVip("异性匹配是会员特权功能，成为会员即刻开启特权匹配!");
      }
    },

    //撩按钮，跳转到聊天
    buildChart(uid) {
      var sysdic = this.$store.state.sysdic;
      var chat_pay_coin = sysdic.chat_pay_coin;
      this.check_uid();

      if (this.checkVip("此功能是会员特权功能，成为会员即刻随意撩~Ta，或者支付"+chat_pay_coin+"金币也可以撩ta哦~",uid)) {
        this.goto_chart(uid);
      }
    },

    match_dtl(tag) {
      //启动动画
      //this.$loading("正在为你匹配...");
      this.$refs.myForm_popup.show();
      var uid = this.$store.state.uid;
      var no_uids = this.get_noUids();
      var self = this;

      // 判断是否是会员，会员2~5秒，非会员3~8秒
      var rnd = tool.randomNum(3, 8);

      if (this.userinfo.vip_level > 0) {
        var rnd = tool.randomNum(2, 5);
      }

      // var rnd = tool.randomNum(10, 15);

      setTimeout(() => {
        self.get({
          url:"/App/Match/?uid=" + uid +"&tag=" +tag +"&uids=" +no_uids.join(","),
          success: function(data) {
            //console.log(JSON.stringify(data));
            self.$refs.myForm_popup.hidden();
            if (data.state == "1") {
              //修改匹配次数
              if (tag == 0) {
                self.$store.commit('set_objVal', {"match_rand" : parseInt(data.match_rand) + 1});
              }
              if (tag == 1) {
                self.$store.commit('set_objVal', {"match_diff" : parseInt(data.match_diff) + 1});
              }

              self.$toast.center("匹配成功!");
              self.goto_chart(data.msg);
              if (self.$store.state.objVal.setting.msg_vol_1) {
                tool.playSound_match();
              }
            } else if (data.state == "2") {
              //今日匹配次数已用完
              self.$toast.center("别戳了,去聊会儿天吧~");
              //后续开发购买次数功能

              //会员提示
              /*
              self.$refs.myForm_buyVip.show(
                "今日匹配已达上限，成为会员可无限次匹配",
                {
                  type: "confirm",
                  confirmText: "升级会员",
                  titleText: "温馨提示",
                  data: ""
                }
              );
              */
            } else if(data.state == "-2"){
              //获取封号信息
              var kill_info = self.$store.state.kill_info;
              if (!kill_info) {
                  self.act_get_killinfo(uid);
              }
              else{
                if (kill_info) {
                  self.$refs.show_kill.show();
                }
              }
              //清理掉聊天记录
              self.$store.commit('clear_message', '');
              self.$toast.center("该账号已被系统禁封!");
            }
            else {
              self.$toast.center("哎呀,没有匹配到,换个姿势试试~");
            }
          },
          error: function(res) {
            //消掉动画,并提示出错啦
            //self.$loading.close();
             self.$refs.myForm_popup.hidden();
            self.$toast.center("哎呀,出错了,请重新匹配");
          }
        });
      }, rnd * 1000);
    },

    init_user(uid) {
      var self = this;
      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          self.userinfo.coin_left = u.coin_left;
          self.userinfo.vip_level = u.vip_level;
          self.userinfo.vip_tag = u.vip_tag;
          self.userinfo.sex = u.sex;
          

          //新用户，跳转注册
          if (u.reg_complete == "0") {
            self.$router.push({ name: "reg_sex" });
          }

          //渠道商老用户，跳转关注公众号
          if (u.reg_complete == "1") {
            if (self.check_jump_gzh()) {
              localStorage.setItem("loc_set_gotoWxgz", JSON.stringify(new Date().getTime()));
              self.$router.push({ name: "reg_wxgz" });
            }
          }
        },
      });
    },

    check_jump_gzh() {
      var rtn = false;
      //没有分站标识
      var fz_tag = this.$store.state.fz_tag;
    
      if (!fz_tag) {
        rtn = false;
        return rtn;
      }

      var uid = this.$store.state.uid;
      if (uid == fz_tag) {
        rtn = false;
        return rtn;
      }
     

      var loc = localStorage.getItem("loc_set_gotoWxgz");
      //第一次从分站链接进来，就提示
      if(!loc){
        rtn = true;
        return rtn; 
      }
      else{//时间超过3分钟，再次从分站进入，则跳转
        var timeDiff = 0;
        var dtm_old = parseInt(loc);
        var dtm = new Date().getTime();
        timeDiff = dtm - dtm_old; // 计算时间差
        if (timeDiff > 3 * 60 * 1000) {
          rtn = true;
        }
      }

      return rtn;
    },

    init_festivalActivities() {
      //使用缓存数据
      var festival_info = this.$store.state.objVal.festival_info;
      if (festival_info !== "") {
        this.festival_info = festival_info;
        return false;
      }

      var uid = this.$store.state.uid;
      var self = this;
      //加载配置数据
      self.get({
          url: "/App/GetCnfigMem_Fest/?uid=" + uid,
          success: function (data) {
            self.festival_info = data;
            self.$store.commit('set_objVal', {"festival_info":data});
          },
      });
    },

    get_setting(){
      var setting = this.$store.state.objVal.setting;
      //console.log("setting:" + JSON.stringify(setting));
      if(setting){
        return false;
      }

      var uid = this.$store.state.uid;
      var self = this;
      self.get({
        url:"/App/GetSettingData?uid=" + uid,
        success: function(data) {
          //console.log(JSON.stringify(data));
          if(data){
            //修改全局参数
            self.$store.commit('set_objVal', {"setting":data});
          }
        },
        error: function(res) {}
      });
    },

    //获取最近在线用户数据
    get_least_user() {
      var least_cur = [];
      var least_pre = this.$store.state.least_online;

      var uid = this.$store.state.uid;
      var dtm_start = "";

      if (least_pre.length > 0) {
        least_cur = least_cur.concat(least_pre);
        dtm_start = least_pre[0].dtm;
      }

      //根据时间间隔控制是否需要到后台获取最新数据
       var tsp = tool.dateDiff2(new Date(dtm_start), new Date());
       if (tsp < 30) {
        this.loading_tag.recommend_user = true;
         return false;
       }

      var self = this;
      self.get({
        url: "/App/GetLeastOnlineUser/?uid=" +uid +"&dtm_start=" + dtm_start,
        success: function(data) {
          self.loading_tag.recommend_user = true;
          //console.log(JSON.stringify(data));
          if (data) {
            var dtm = new Date();
            for (var i in data) {
              var user_item = data[i];

              //存在，则先删除
              var idx = tool.hasKey(least_cur, user_item.uid, "uid");
              if (idx >= 0) {
                least_cur.splice(idx, 1);
              }

              user_item.photo = self.$store.state.url + "/photo/" + user_item.photo;
              user_item.dtm = dtm.Format("yyyy/MM/dd hh:mm:ss");
              user_item.dtm_sp = "1秒";

              //再添加
              least_cur.push(user_item);
            }
            self.$store.commit("push_least_online", least_cur);
            //self.$store.dispatch('act_set_online_count', least_cur.length);
          }
        },
        error: function(res) {}
      });
    },

    //获取榜单数据
    get_rank_data1() {
      var self = this;

      var index_rank1 = this.$store.state.http_cache.index_rank1;
      var dtm = index_rank1.dtm;
      
      var dtm_now = new Date().getTime();

      var timeDiff = (dtm_now - dtm ) / (1000 * 60); //相差时间
      if (timeDiff < 10) {
        this.loading_tag.rank1 = true;
        var data = index_rank1.data_serve;
        this.ary1 = this.process_rank(data)
        return false;
      }

      self.get({
        url: "/App/GetRank/?s1=1&s2=1",
        success: (data) => {
          self.loading_tag.rank1 = true;
          var obj = {
            dtm: new Date().getTime(),
            data_serve: data
          }
          self.$store.commit("set_http_cache", {index_rank1: obj});
          self.ary1 = self.process_rank(data);
        },
        error: (error) => {
          console.error(error);
        }
      });

     
    },

    get_rank_data2() {
      var self = this;

      var index_rank2 = this.$store.state.http_cache.index_rank2;
      var dtm = index_rank2.dtm;

      var dtm_now = new Date().getTime();

      var timeDiff = (dtm_now - dtm ) / (1000 * 60); //相差时间
      if (timeDiff < 10) {
        this.loading_tag.rank2 = true;
        var data = index_rank2.data_serve;
        this.ary2 = this.process_rank(data)
        return false;
      }

      self.get({
        url: "/App/GetRank/?s1=2&s2=1",
        success: (data) => {
          self.loading_tag.rank2 = true;
          var obj = {
            dtm: new Date().getTime(),
            data_serve: data
          }
          self.$store.commit("set_http_cache", {index_rank2: obj});
          self.ary2 = self.process_rank(data);
        },
        error: (error) => {
          console.error(error);
        }
      });
    },


    // 处理榜单数据
    process_rank(ary_rank) {
          var arr_rtn = [];
          var ary_top3 = ary_rank.slice(0, 3);
          var item;
          for (var i = 0; i < ary_top3.length; i++) {
           item = this.$store.state.url + "/photo/" + ary_top3[i].photo;  
           arr_rtn.push(item); 
          }   
      return arr_rtn;
    },
    
    //检查uid，没有获取到重新加载页面
    check_uid(){
      var uid = this.$store.state.uid;
      console.log("首页检查uid是否获取成功,uid:" + uid);

      if(!uid){
        //刷新页面，仅在微信环境下进行刷新
        var client = this.$store.state.client;
        if (client.is_wx) {
          window.location.reload(true);
        }
      }
    },

    //测试版本号是否一致，解决上线缓存问题
    check_appVersion(app_version_serve){

      var sysdic = this.$store.state.sysdic;
      if(sysdic){
        var app_version_serve = sysdic.app_version;
        var app_version = this.$store.state.app_version;

        var serve_Verion = app_version_serve.replace(".","").replace(".","");
        var local_Verion = app_version.replace(".","").replace(".","");
        console.log(local_Verion + "---服务器端：" + serve_Verion);
        if(parseInt(local_Verion) < parseInt(serve_Verion)){
          //清理掉所有的缓存，并重新加载页面
          //this.clearCookie();
          window.location.reload(true);
        }
      }

    },
    clearCookie() {
      var keys = this.$cookies.keys();
      var count = keys.length;
      for (var i in keys) {
        this.$cookies.remove(keys[i]);
      }
      localStorage.clear();
      console.log("共清理了 " + count + " 项");
    },

    //处理动态高度
    wnd_ctrl(){
      var h4 = 45;
      var sysdic = this.$store.state.sysdic;
      if (sysdic) {
         //检查节日活动
         if (sysdic.fest_vip == "1") {
            h4 = 0;
         }
       }

      var h1 = window.innerHeight;
      var h2 = document.getElementById("region_top").clientHeight;
      var h3 = document.getElementById("region_recommend_head").clientHeight;
      this.h = (h1 - h2 - h3 - 100 ) + h4  + "px";
    },


    //判断跳转到豪气或魅力榜
    goto_rank(s1, s2) {
      this.$router.push({ name: "rank", params: { s1: s1, s2: s2 } });
    },

    //根据uid跳转到对应的聊天
    goto_chart(uid) {
      this.$router.push({ name: "chart", params: { uid: uid } });
    },

    goto_chart_admin() {
      var sysdic = this.$store.state.sysdic;
      if(sysdic) {
        var xhc_admin_uid = sysdic.xhc_admin_uid;
        this.$router.push({ name: "chart_admin", params: { uid: xhc_admin_uid } });
      } else {
        this.$toast.center('未获取到官方客服uid');
      }
    },
    goto_guidebook() {
      this.$router.push({name: "guidebook"});
    },
    
    get_noUids() {
      //只取最近的10个uid
      var arr_nouid = [];
      var message = this.$store.state.message;
      var arr_temp = tool.msg_sort(message);

      for (var i in arr_temp) {
        if (i >= 10) {
          break;
        }
        arr_nouid.push(arr_temp[i].uid);
      }
      return arr_nouid;
    },

    checkVip(msg, uid_to) {
      var b = true;
      var vip_level = this.userinfo.vip_level;
      if (vip_level == 0) {
        //购买会员提示
        if (uid_to) {
          this.$refs.myForm_vip_pay.show(msg, {
            type: "confirm",
            confirmText: "升级会员",
            cancelText: "支付金币",
            titleText: "温馨提示",
            data: uid_to
          });
        } else {
          this.$refs.myForm_buyVip.show(msg, {
            type: "confirm",
            confirmText: "升级会员",
            titleText: "温馨提示",
            data: uid_to
          });
        }
        
        return false;
      }
      return b;
    },

    formact_vip_pay(type, data) {
      if (type == "clickConfirm") {
        this.$router.push({ name: "vip_center" });
      }
      if (type == "clickCancel") {
          var uid = this.$store.state.uid;
          var sysdic = this.$store.state.sysdic;
          var coin = sysdic.chat_pay_coin;
          //判断剩余金币
          if (this.userinfo.coin_left < coin) {
              if (this.userinfo.sex == "男生") {
                this.$refs.myConfirm_buyCoinOrChatCoin.show("金币余额不足,请先充值，你也可以选择免费赚金币~", {
                  type: "confirm",
                  confirmText: "去购买",
                  cancelText: "赚金币",
                  titleText: "温馨提示",
                  data: "",
                });
              return false;
              } else {
                this.$refs.myConfirm_buyCoin.show("金币余额不足,请先充值哦", {
                  type: "confirm",
                  confirmText: "去购买",
                  titleText: "温馨提示",
                  data: "",
                });
                return false;
              }
          } 
          
          var data = {
            "uid": uid,
            "coin": coin,
            "uid_to": data
          };
          this.sub_coin_relieve(data);
      }
    },

    formact_buyVip(type, data) {
      if (type == "clickConfirm") {
        this.$router.push({ name: "vip_center" });
      }
    },

    //扣除金币
    sub_coin_relieve(data) {
      var send_data = {
        "uid_from": data.uid,
        "uid_to": "",
        "amount": data.coin,
        "type_dtl": "打招呼",
        "comment": "",
      };
      var self = this;
       self.act_sub_coin({
         uid: data.uid,
         strSend: JSON.stringify(send_data),
         success: function (res) {
           if (res.state == "1") {
            var to_uid = data.uid_to;
            self.goto_chart(to_uid);
           }
         },
       });
      },

    format_online: function(data) {
      //处理数据，增加时间戳
      for (var i in data) {
        var dtm = new Date(data[i].dtm);
        var dtm_now = new Date();
        var sp = tool.dateDiff(dtm, dtm_now);
        if (sp == "0秒") {
          sp = "1秒";
        }
        data[i].dtm_sp = sp;
      }
      //排序
      data = tool.arry_sort(data, "dtm", "dtm_desc");
      return data;
    },

    formact_buycoin(type, data) {
        if (type == 'clickConfirm') {
            this.$router.push({ name: "mycoin" });
        }
    },

    formact_buycoin_chatcoin(type, data) {
      if (type == "clickConfirm") {
        this.get_gotoName();
      }
      if (type == "clickCancel") {
        this.$router.push({ name: "task_coin" });
      }
    },

    get_gotoName() {
      var name = "mycoin";
      //增加跳转到首充的条件
      var uid = this.$store.state.uid;
      var self = this;
      self.get({
        url: "/App/GetVip_AttachInfo/?uid=" + uid,
        success: function (data) {
          if (data.vip_first == "False" && data.svip_first == "False") {
            name = "first_charge";
          }
          
          if (name == "mycoin") {
            self.$router.push({ name: "mycoin" });
          }
          if (name == "first_charge") {
            self.$refs.first_charge.show();
          }
        },
      });
    },

    //公告详情
    notice_dtl() {
      this.$refs.festival_activity.show(this.festival_info);
    }

  },
};
</script>
<style lang="scss" scoped>
.container {
  min-height: 100vh;
  padding: 0 1rem;
  background-color: #1f1b2a;
  background-image: url(../assets/img/new2024/bg-index.png);
  background-size: 100% 100%;
}
#region_top {
  padding-top: 1rem;
}
.top-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .ranking {
    display: flex;
    flex: 1;
      .ranking-card {
      width: 6.1rem;
      display: flex;
      flex-direction: column;
      padding: 0.62rem;
      border-radius: 0.62rem;
      margin-right: 0.62rem;
      height: 3rem;
    }
    .ranking-card:nth-child(1) {
      background-image: url(../assets/img/new2024/bg-arrogance.png);
      background-size: 100% 100%;
    }
    .ranking-card:nth-child(2) {
      background-image: url(../assets/img/new2024/bg-charm.png);
      background-size: 100% 100%;
    }
    .ranking1 {
      display: flex;
      align-items: center;
      height: 1.5rem;
      span {
        font-size: 0.87rem;
        margin-left: 0.2rem;
        margin-bottom: 0.62rem;
        color: #fff;
      }
        img {
        width: 0.9rem;
        height: 0.7rem;
        margin-bottom: 0.8rem;
        margin-left: 0.3rem;
      }
    }
    .ranking2 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .image-container {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        justify-items: center;
        align-items: center;
        position: relative;
        .image {
          width: 1.3rem;
          height: 1.3rem;
          background-size: cover;
          background-position: center;
          border-radius: 50%;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
          position: relative;
          z-index: 1;
        }
        .image:nth-child(1) {
          grid-column: 1 / 2;
          transform: translateX(30%);
          z-index: 1;
        }
        .image:nth-child(2) {
          grid-column: 2 / 3;
          z-index: 2;
        }
        .image:nth-child(3) {
          grid-column: 3 / 4;
          transform: translateX(-30%);
          z-index: 3;
        }
      }
    }
  }
  .actions {
    width: 5rem;
    display: flex;
    justify-content: space-between;
    .action-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #fff;
        span {
          font-size: 0.6rem;
        }
      .action-icon {
        width: 2rem;
        height: 2rem;
        margin-bottom: 0.31rem;
        border-radius: 50%;
        background-color: #4e628c;
        display: flex;
        justify-content: center;
        align-items: center;
        .new-friends {
          width: 1.7rem;
          height: 1.7rem;
        }
        .feedback {
          width: 1.2rem;
          height: 1.2rem;
        }
      }
    }
  }
}

.match-section {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  .match-option {
    width: 10rem;
    height: 6rem;
    display: flex;
    flex-direction: column;
    border-radius: 0.62rem;
    padding-left: 0.75rem;
    color: #fff;
    .text {
      font-size: 0.7rem;
      margin-top: 0.5em;
    }
  }

  .match-option span:nth-child(1) {
    margin-top: 3rem;
  }
  .match-option:nth-child(1) {
    margin-right: 1rem;
    background-image: url(../assets/img/new2024/bg-matching1.png);
    background-size: 100% 100%;
  }
  .match-option:nth-child(2) {
    background-image: url(../assets/img/new2024/bg-matching2.png);
    background-size: 100% 100%;
  }
}

.notice {
  padding: 0.3rem 0.5rem;
  margin-top: 1rem;
  font-size: 0.9rem;
  border-radius: 0.5rem;
  color: #fcdd7f;
  background-color: #ab68de;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  span {
    margin-left: 0.2rem;
  }
  .scroll-container {
    width: 100%;
    overflow: hidden;
  }

  .scroll-text {
    display: inline-block;
    white-space: nowrap;
    animation: scroll-left-to-right 10s linear infinite;
  }

  @keyframes scroll-left-to-right {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(-100%);
    }
  }
}

.online-count {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
    color: #fff;
    .online-users {
      font-size: 0.75rem;
      margin-right: 1rem;
      span {
        color: #a264e7;
      }
    }
  }

.recommend-section {
  flex: 1;
  overflow-y: auto;
  scrollbar-width: none; /* firefox 不显示滚动条 */
  -ms-overflow-style: none; /* IE 10+ 不显示滚动条 */
  .user-card {
    height: 5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(to right, #1f1b2a, #67598e);
    padding: 0.4rem;
    border-radius: 0.62rem;
    margin-bottom: 0.62rem;
    .user-info {
      display: flex;
      align-items: center;
      color: #fff;
      .avatar {
        margin-right: 0.62rem;
        img {
          width: 3.5rem;
          height: 3.5rem;
          border-radius: 50%;
        }
      }
      .details {
        height: 5rem;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
          .information1 {
            display: flex;
            align-items: center;
            .age-range {
              padding:1px 2px;
              border: 1px solid #999;
              border-radius: 3px;
              font-size: 0.7rem;
              margin-left: 0.5rem;
              display: flex;
              justify-content:space-evenly;
              align-items: center;
              img {
                width: 0.8rem;
                height: 0.8rem;
              }
              span {
                font-size: 0.6rem;
              }
            }
            span{
              font-size: 0.9rem;
            }
          }
          .information2 {
            display: flex;
            .crad-value {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 0.7rem;
              padding:1px 2px;
              border-radius:3px;
              border:1px solid #dcdcdc;
              span {
                font-size: 0.6rem;
              }
            }
            
          }
          .details-state {
            color: rgba(255, 255, 255, 0.5);
            font-size: 0.7rem;
          }
      }
    }
    .match-button {
      background: linear-gradient(#8a61ff, #fe9cc0);
      color: white;
      border: none;
      border-radius: 2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      span {
        font-size: 0.9rem;
        margin-left: 1rem;
        margin-right: 0.5rem;
      }
      .love {
        width: 2rem;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: 1px solid #fff;
        background: linear-gradient(#8a61ff, #fe9cc0);
        img {
          margin-top: 0.5rem;
          margin-left: 0.1rem;
          width: 1.5rem;
          height: 1.5rem;
        }
      }
    }
  }
}

.recommend-section::-webkit-scrollbar {
  display: none; /* Chrome Safari 不显示滚动条 */
}


.no-404 {
  min-height: 100vh;
  background-image: url(../assets/img/new2024/bg-index.png);
  background-size: 100% 100%;
  .tip-404 {
    margin-top: 1rem;
    font-size: 0.75rem;
  }
  .btn-404 {
    margin-top: 1rem;
    padding: 0.5rem 1rem;
    border-radius: 1rem;
    background: linear-gradient( 90deg, #A264E7 0%, #FE9CC0 100%);
    span {
      font-size: 0.9rem;
      color: #FFF;
    }
  }
}
</style>
